import { Link, PlaceholderImage, Price, Typography, WroomImage } from '@components'
import { Search as SearchComponent } from '@haus-storefront-react/search'
import type { SearchResult } from '@haus-storefront-react/shared-types'
import type { SearchConfigStyles } from './types'
import styles from './Search.module.scss'

interface SearchProductListProps {
  items: SearchResult[]
  configStyles?: SearchConfigStyles
}

export function SearchProductList({ items, configStyles }: SearchProductListProps) {
  return (
    <ul className={styles.resultsList}>
      {items.map((product) => (
        <SearchComponent.ProductItem key={product.productId} product={product}>
          <li className={styles.resultItem}>
            <Link
              href={`/produkter/${product.slug}`}
              className={styles.resultLink}
              aria-label={`${product.productName}${product.productVariantName ? ` - ${product.productVariantName}` : ''}`}
            >
              <div className={styles.resultImageWrapper}>
                {product.productAsset?.preview ? (
                  <WroomImage
                    src={product.productAsset.preview}
                    className={styles.resultImage}
                    alt={product.productName}
                    width={64}
                    ratio="1:1"
                  />
                ) : (
                  <PlaceholderImage className={styles.resultImage} />
                )}
              </div>
              <div className={styles.resultMain}>
                <div className={styles.resultContent}>
                  <span className={styles.productName}>
                    <Typography
                      variant={configStyles?.nameTypography?.variant ?? 'body'}
                      as={configStyles?.nameTypography?.tag ?? 'span'}
                      color={configStyles?.nameTypography?.color ?? 'body'}
                      style={{ textDecoration: 'inherit' }}
                    >
                      {product.productName}
                    </Typography>
                  </span>
                  {product.productVariantName && (
                    <Typography
                      variant="body"
                      as="span"
                      color="body"
                      className={styles.productVariant}
                    >
                      {product.productVariantName}
                    </Typography>
                  )}
                </div>
                <div className={styles.resultPrice}>
                  <SearchComponent.Price>
                    {({ price, priceWithTax, currencyCode }) => (
                      <Price
                        price={price}
                        priceWithTax={priceWithTax}
                        currencyCode={currencyCode}
                        product={product}
                        identifier={product.productVariantId}
                        themeConfig={{
                          priceTypography: {
                            variant: configStyles?.productPriceTypography?.variant ?? 'body',
                            tag: configStyles?.productPriceTypography?.tag ?? 'span',
                            color: configStyles?.productPriceTypography?.color ?? 'body',
                          },
                        }}
                        className={styles.price}
                      />
                    )}
                  </SearchComponent.Price>
                </div>
              </div>
            </Link>
          </li>
        </SearchComponent.ProductItem>
      ))}
    </ul>
  )
}
